<template>
  <v-icon
    :size="size"
    :color="isFavorite ? 'customNavColor' : undefined"
    :aria-label="$t('labels.favorite') || 'Favorite'"
    :aria-pressed="isFavorite"
    role="button"
    tabindex="0"
    :class="['favorite-star', { 'is-favorite': isFavorite, 'force-visible': forceVisible }]"
    @click.stop.prevent="$emit('toggle')"
    @keydown.enter.stop.prevent="$emit('toggle')"
    @keydown.space.stop.prevent="$emit('toggle')"
  >
    {{ isFavorite ? 'mdi-star' : 'mdi-star-outline' }}
  </v-icon>
</template>

<script setup>
defineProps({
  isFavorite: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'small'
  },
  forceVisible: {
    type: Boolean,
    default: false
  }
})

defineEmits(['toggle'])
</script>

<style scoped lang="scss">
// Opacity levels for star visibility states
$opacity-hidden: 0;
$opacity-hover: 0.6;
$opacity-full: 1;

.favorite-star {
  opacity: $opacity-hidden;
  // Prevent accidental clicks when star is invisible
  pointer-events: none;
  transition: opacity 0.2s ease;
  cursor: pointer;
  border-radius: 50%;

  &.force-visible {
    opacity: $opacity-hover;
    pointer-events: auto;
  }

  &:hover,
  &:focus,
  &:focus-visible {
    opacity: $opacity-full;
  }

  // Custom focus ring since we're not using v-btn
  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  // Favorited items show at full opacity when parent is hovered
  &.is-favorite.force-visible {
    opacity: $opacity-full;
  }
}
</style>
